import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=c8891674&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=c8891674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8891674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8891674')) {
      api.createRecord('c8891674', component.options)
    } else {
      api.reload('c8891674', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=c8891674&scoped=true&", function () {
      api.rerender('c8891674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V86i30HdjsvT/JS/comp/PopupDialog.vue"
export default component.exports